import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { CommonAxiosGet, CommonAxiosPut } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from "yup";
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
export default function InspChairPersonDetails() {
    const [chairPersonData, setChairPersonData] = useState([]);
    const validationSchema = Yup.object({
        chairPerson: Yup.array().of(
            Yup.object({
                recommendedStatus: Yup.string().required("Recommended is required"),
                // remarks: Yup.string().required("Remarks is required")
            })
        )
    });
    const formik = useFormik({
        initialValues: { chairPerson: [] },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => submitChairPersonDetails(values)
    });
    function getInspectionChairPersonDetails() {
        let url = config.url.FAC_URL + "getSocietyNameChange";
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const data = res?.data?.chairPerson || [];
                    setChairPersonData(res?.data?.chairPerson || []);
                    formik.setValues({
                        chairPerson: data?.map(cp => ({
                            sno: cp.sno,
                            recommendedStatus: cp.recommended_status ? cp.recommended_status : "",
                            remarks: cp.remarks || ""
                        })
                        )
                    })
                } else {
                    setChairPersonData([]);
                    formik.setValues({ chairPerson: [] });
                }
            })
            .catch((e) => {
                console.error(e);
                setChairPersonData([]);
                formik.setValues({ chairPerson: [] });
            });
    }
    function submitChairPersonDetails(values) {
        if (!values.chairPerson || values.chairPerson.length === 0) {
            failureAlert("No data to submit!");
            return;
        }
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit all recommendations?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.FAC_URL + "updateChairPerson";
                CommonAxiosPut(url, values.chairPerson)
                    .then((res) => {
                        if (res && res.data.status === true) {
                            successAlert2(res?.data?.sdesc);
                            getInspectionChairPersonDetails();
                        } else {
                            failureAlert(res?.data?.sdesc || "Submission Failed");
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        failureAlert("Something went wrong!");
                    });
            }
        });
    }
    useEffect(() => {
        getInspectionChairPersonDetails();
    }, []);
    const isAlreadySubmitted = chairPersonData.every(
        item => item.recommended_status !== null && item.recommended_status !== ""
    );
    return (
        <Container fluid className="py-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    {chairPersonData.length > 0 ? (
                        <div className="mb-4">
                            {/* <h6 className="text-success mb-2"><b>Chairperson Details</b></h6> */}
                            <h5 className="mb-3 innerheader-new">
                                <span>Chairperson Details</span>
                            </h5>
                            <Table bordered responsive>
                                <thead className="table-primary">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Role</th>
                                        <th>Contact</th>
                                        <th>Address</th>
                                        <th>Responsibilities</th>
                                        <th>Recommended</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chairPersonData.map((cp, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{cp.name_of_chairperson}</td>
                                            <td>{cp.role}</td>
                                            <td>{cp.contact}</td>
                                            <td>{cp.address}</td>
                                            <td>{cp.responsibilities}</td>

                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-3">
                                                    <label>
                                                        <Field
                                                            type="radio"
                                                            name={`chairPerson.${index}.recommendedStatus`}
                                                            value="YES"
                                                            disabled={!!cp.recommended_status}
                                                        /> &nbsp;Yes
                                                    </label>

                                                    <label>
                                                        <Field
                                                            type="radio"
                                                            name={`chairPerson.${index}.recommendedStatus`}
                                                            value="NO"
                                                            disabled={!!cp.recommended_status}
                                                        />&nbsp; No
                                                    </label>
                                                </div>

                                                <ErrorMessage
                                                    name={`chairPerson.${index}.recommendedStatus`}
                                                    component="div"
                                                    className="text-danger small"
                                                />
                                            </td>

                                            <td>
                                                <Field
                                                    type="text"
                                                    name={`chairPerson[${index}].remarks`}
                                                    className="form-control"
                                                    placeholder="Enter remarks"
                                                    disabled={!!cp.recommended_status}
                                                />

                                                <ErrorMessage
                                                    name={`chairPerson[${index}].remarks`}
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        // <div className="text-center mt-4">
                        //     <h6 className="text-danger">No Data Found</h6>
                        // </div>
                        <center className="text-danger mt-4 h5">
                            {" "}
                            ***** No Data Found *****{" "}
                        </center>

                    )}
                    {chairPersonData.length > 0 && (
                        <Row className="mt-4">
                            <Col xs={12} className="text-end">
                                {!isAlreadySubmitted ? (
                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>
                                ) : (
                                    <span className="text-success fw-bold">
                                        Already Submitted
                                    </span>
                                )}

                            </Col>
                        </Row>
                    )}
                </Form>
            </FormikProvider>
        </Container>
    );
}